import React from 'react';
import { Alert } from 'antd';
import { getDeclinedWord } from '../../utils/getDeclinedWord';

const messageFun = (type, countFlats) => {
  return type + ' ' + getDeclinedWord(countFlats);
};

const InformationBlockModal = ({ typeMassActions, count, accessMessage }) => {
  return (
    <Alert
      showIcon
      message={messageFun(typeMassActions, count)}
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
      }}
      type="info"
      description={
        <div style={{ marginTop: '8px' }}>
          {accessMessage && (
            <div style={{ color: '#0995ED', marginBottom: '5px' }}>
              {accessMessage}
            </div>
          )}
          <div>Вы уверены, что хотите продолжить?</div>
        </div>
      }
    />
  );
};

export default InformationBlockModal;

export const InfoBlockModalWithoutAction = ({
  message,
  description,
  type = 'info',
}) => {
  return (
    <Alert
      showIcon
      message={message}
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
      }}
      type={type}
      description={
        <div
          style={{
            color: type === 'error' ? '#f5222d' : '#0995ED',
          }}
        >
          {description}
        </div>
      }
    />
  );
};
